export default [
  {
    text: 'ABERTA',
    value: 'ABERTA',
  },
  {
    text: 'FECHADA',
    value: 'FECHADA',
  },
  {
    text: 'CANCELADA',
    value: 'CANCELADA',
  },
];
